import { ApexApiError } from 'apex-ui-services'
import { Dispatch } from 'redux'
import {
  BAD_REQUEST,
  TEMPORARILY_UNAVAILABLE,
  UNAUTHORIZED,
} from 'actions/constants'
import { HttpResponseStatusCodes } from 'constants/HttpResponseStatusCodes'

export const createGenericError = (
  error: ApexApiError,
  dispatch: Dispatch,
  actionType: string,
  onError: (error: string) => void
) => {
  const httpResponseStatus = error.response?.status
  let errorMessage: string = ''

  switch (httpResponseStatus) {
    case HttpResponseStatusCodes.Unauthorized:
      errorMessage = UNAUTHORIZED
      break
    case HttpResponseStatusCodes.InternalServerError:
    case HttpResponseStatusCodes.ServiceUnavailable:
      errorMessage = TEMPORARILY_UNAVAILABLE
      break
    case HttpResponseStatusCodes.BadRequest:
      errorMessage = BAD_REQUEST
      break
    default:
      break
  }
  dispatch({ type: actionType })
  errorMessage && onError(errorMessage)
}
